import logger from '../../services/logger';

import React, { useEffect, useState } from "react";
import { useParams} from "react-router-dom";
import { Button } from "react-bootstrap";
import AppBadge from "../common/AppBadge";
import badgeService from '../../services/animation.service'
import { PageTitle } from "../common/Header";
import SocialShareIcons from "../common/SocialShareIcons";


const BadgeDetailPage = () => {
  const { badgeId } = useParams();
 
  const [badge, setBadge] = useState(null);
  const [text, setText] = useState(null);
  const [url, setUrl] = useState(null);

  useEffect(() => {
    const fetchBadge = async () => {
      try {
        const data = await badgeService.getBadgeById(badgeId);
        setBadge(data);
        const text = `Je viens de gagner le badge ${data.refbadge.name} sur DCARE ! 💚`;
        const url = "https://app.dcare.io/public/badges/"+data.publicUuid;
        setUrl(url);
        setText(text);

      } catch (error) {
        logger.log("Erreur lors de la récupération du badge:", error);
      }
    };
    fetchBadge();
  }, [badgeId]);


  if (!badge) return <div className="white-background p-4">Chargement...</div>;

  return (
    <div className="white-background">
      <PageTitle title={"Badge obtenu"} />

      <div className="text-center mt-4">
         <AppBadge image={badge.refbadge.pict} alt={badge.refbadge.name}/>

        <h3 className="mt-3">{badge.refbadge.name}</h3>
        
        <blockquote className="blockquote text-muted">
            <p className="mb-0">« {badge.refbadge.description} »</p>
        </blockquote>
        
        <p style={{ fontSize: '0.8rem' }}>Gagné le : {new Date(badge.dt_obtention).toLocaleDateString()}</p>

        <div className="mt-4 p-3 rounded shadow-sm bg-light text-start">
          <h6 className="fw-bold">🎁 Bonus débloqué</h6>
          {badge.bonus ? (
            <>
              <p className="mb-1">{badge.bonus.description}</p>
              {badge.bonus.link && (
                <Button
                  variant="success"
                  size="sm"
                  href={badge.bonus.link}
                  target="_blank"
                >
                  Profiter du bonus
                </Button>
              )}
            </>
          ) : (
            <p>Aucun bonus spécifique, juste toute notre reconnaissance 💚</p>
          )}
        </div>

        <div>
            <SocialShareIcons pageUrl={url} shareText={text}/>
        </div>
      </div>
      <br/><br/>
    </div>
  );
};

export default BadgeDetailPage;